const compare=require("./compare"),gt=(a,b,loose)=>compare(a,b,loose)>0;module.exports=gt;